import { action } from 'easy-peasy';

export default {
  value: 1,
  setTabValue: action((state, payload) => {
    state.value = payload;
  }), 
};
